import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTelevisionOld: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconTelevisionOld"><Path d="M7.10535 2.69305C7.27488 2.47508 7.58902 2.43581 7.80699 2.60535L12 5.86659L16.1931 2.60535C16.411 2.43581 16.7252 2.47508 16.8947 2.69305C17.0642 2.91103 17.025 3.22516 16.807 3.3947L13.4573 6H19.5C20.8807 6 22 7.11929 22 8.5V18.5C22 19.8807 20.8807 21 19.5 21H4.5C3.11929 21 2 19.8807 2 18.5V8.5C2 7.11929 3.11929 6 4.5 6H10.5427L7.19305 3.3947C6.97508 3.22516 6.93581 2.91103 7.10535 2.69305Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTelevisionOld;
